import { Box, Button, Card, Grid2, IconButton, List, ListItem, ListItemText, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import Loader from "../../util/Loader";
import LoadingAwal from "../../util/LoadingAwal";
import Barcode from "react-barcode";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';


const Gopay = ({user_id, invoice_id}) => {
    const [loading, isLoading] = useState(true);
    const [error, isError] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [rows, setRows] = useState({});
    const navigate = useNavigate();
     
    useEffect(() => {
        const init = () => {
            if(user_id && invoice_id) {
                axios.get(`https://ssr.radboox.com/data/xendit/ewallet_gopay/${user_id}?invoice_id=${invoice_id}`)
                .then((res) => {
                    const data = res.data.message;
                    // setRows(data)
                    // isLoading(false)
                    window.open(data, "_self");
                }).catch((e) =>{
                    isError(true)
                    setErrorMsg(e.response.data.message)
                    isLoading(false)
                })
            }
        }
        init();
    }, [user_id, invoice_id])

    const copyText = async() => {
        navigator.clipboard.writeText(rows?.payment_code);
        try {
            await navigator.clipboard.writeText(rows?.payment_code);
            /* Resolved - text copied to clipboard successfully */
        } catch (err) {
            // console.error('Failed to copy: ', err);
            /* Rejected - text failed to copy to the clipboard */
        }
    }

    return(
       <>
        {loading ? (
            <>
                <Loader />
                <LoadingAwal /> 
            </>
        ) : (
            <>
                {error ? (
                    <>
                        <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column">
                            <Typography variant="body1">Mohon maaf, permintaan Anda tidak dapat di lanjutkan</Typography>
                            <Typography variant="body2">error code: {errorMsg}</Typography>
                            <Button sx={{marginY: 2, paddingX: 4, marginTop: 5}} variant="contained" onClick={() => navigate(-1)}>Kembali</Button>
                        </Box>
                    </>
                ) : (
                    <>
                        <Grid2 container justifyContent="center" margin={2}>
                            <Grid2 size={{xs: 12, sm: 8}}>
                                <img
                                    src={`https://content.radboox.com/public/upload/img/${rows?.cp_logo}`}
                                    alt="Company Profile"
                                    style={{
                                        align: "left",
                                        maxHeight: "70px",
                                        objectFit: "contain",
                                        backgroundColor: "#fff",
                                    }}
                                />
                                <Typography variant="h6" sx={{fontWeight: 800}}>{rows?.cp_name}</Typography>
                            </Grid2>
                        </Grid2>
                        <Grid2 container justifyContent="center"> 
                            <Grid2 size={{xs: 12, sm: 8}}>
                                <Card variant="outlined" sx={{padding: 1}}>
                                    <Grid2 container padding={2} spacing={2}>
                                        <Grid2 size={{xs: 12, sm: 6}} order={{ xs: 2, sm: 1 }}>
                                            <Typography variant="body2">Kode Pembayaran</Typography>
                                            <Typography variant="h5" sx={{marginBottom: 2}}>{rows?.payment_code}<IconButton onClick={() => copyText()} sx={{marginLeft: 2}} size="small"><ContentCopyIcon fontSize="inherit"/></IconButton></Typography>
                                            <Typography variant="body2">Bayar Kepada Merchant</Typography>
                                            <Typography variant="h5" sx={{marginBottom: 2}}>Xendit</Typography>
                                            <Typography variant="body2">Nama Pelanggan</Typography>
                                            <Typography variant="h6" sx={{marginBottom: 2}}>{rows?.name}</Typography>
                                            <Typography variant="body2">Nominal Bayar</Typography>
                                            <Typography variant="h6">{rows?.expected_amount}</Typography>
                                        </Grid2>
                                        <Grid2 size={{xs: 12, sm: 6}} justifyItems="center" alignContent="center" order={{ xs: 1, sm: 2 }}>
                                            <Typography variant="body2">Tunjukan Kepada Kasir</Typography>
                                            <Barcode value={rows?.payment_code} />
                                            <Typography variant="body2" sx={{marginTop: 2}}>Bayar Sebelum</Typography>
                                            <Typography variant="h6">{rows?.expiration_date}</Typography>
                                        </Grid2>
                                    </Grid2>
                                </Card>
                                <Box sx={{padding: 1}}>
                                    <Typography sx={{ mt: 2}} variant="h6">
                                        Catatan
                                    </Typography>
                                    <List sx={{ listStyle: "decimal", pl: 4 }}>
                                        <ListItem sx={{ display: "list-item", padding: 0 }}>
                                            <ListItemText>
                                                Anda dapat melakukan pembayaran melalui Alfamart Grup (Alfamart, Afamidi, Dan+Dan, Lawson).
                                            </ListItemText>
                                        </ListItem>
                                        <ListItem sx={{ display: "list-item", padding: 0 }}>
                                            <ListItemText>
                                                Anda dapat melakukan pembayaran dibawah Rp. 2,500,000 melalui Alfamart, Afamidi, Dan+Dan, Lawson.
                                            </ListItemText>
                                        </ListItem>
                                        <ListItem sx={{ display: "list-item", padding: 0 }}>
                                            <ListItemText>
                                                Pembayaran diatas Rp. 2,500,000 tidak dapat dilakukan di Alfamidi.
                                            </ListItemText>
                                        </ListItem>
                                    </List>
                                    <Typography sx={{ mt: 1}} variant="h6">
                                        Temukan Cabang Terdekat
                                    </Typography>
                                    <List sx={{ listStyle: "decimal", pl: 4 }}>
                                        <ListItem sx={{ display: "list-item", padding: 0 }}>
                                            <ListItemText>
                                                Kunjungi ALFAMART terdekat sebelum invoice kadaluarsa.
                                            </ListItemText>
                                        </ListItem>
                                        <ListItem sx={{ display: "list-item", padding: 0 }}>
                                            <ListItemText>
                                                Sebutkan pembayaran Xendit ke kasir, atau berikan kode barcode untuk di scan oleh kasir.
                                            </ListItemText>
                                        </ListItem>
                                    </List>
                                    <Typography sx={{ mt: 1}} variant="h6">
                                        Detail Pembayaran
                                    </Typography>
                                    <List sx={{ listStyle: "decimal", pl: 4 }}>
                                        <ListItem sx={{ display: "list-item", padding: 0 }}>
                                            <ListItemText>
                                                Berikan kode pembayaran yang ada di invoice, dan pastikan nominal yang akan dibayarkan sudah benar.
                                            </ListItemText>
                                        </ListItem>
                                        <ListItem sx={{ display: "list-item", padding: 0 }}>
                                            <ListItemText>
                                                Informasikan pada kasir jika Anda ingin membayar menggunakan uang tunai saja, atau kombinasi uang tunai dengan Kartu Debit/Prabayar atau Dompet Digital.
                                            </ListItemText>
                                        </ListItem>
                                        <ListItem sx={{ display: "list-item", padding: 0 }}>
                                            <ListItemText>
                                                Jumlah uang tunai maksimal yang diperbolehkan hanya Rp. 2,500,000, sisanya dapat menggunakan metode Kartu Debit/Prabayar atau Dompet Digital.
                                            </ListItemText>
                                        </ListItem>
                                        <ListItem sx={{ display: "list-item", padding: 0 }}>
                                            <ListItemText>
                                                Lanjutkan pembayaran anda dengan nominal yang disebutkan di invoice.
                                            </ListItemText>
                                        </ListItem>
                                    </List>
                                    <Button sx={{marginY: 2, paddingX: 4}} variant="contained" onClick={() => navigate(-1)}>Kembali</Button>
                                </Box>
                            </Grid2>
                        </Grid2>
                    </>
                )}
            </>
        )}
       </>
    )
};

export default Gopay;